import axios from "axios";
import {
  requestErrorInterceptor,
  requestInterceptor,
} from "./interceptors/requestInterceptor";
import {
  responseErrorInterceptor,
  responseInterceptor,
} from "./interceptors/responseInterceptor";

//link to website
export const link = "https://www.myservice.am";

// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: `${link}/api/v1`,
  headers: {
    "Content-Type": "application/json",
  },
});

// Apply interceptors to the instance
axiosInstance.interceptors.request.use(
  requestInterceptor,
  requestErrorInterceptor
);
axiosInstance.interceptors.response.use(
  responseInterceptor,
  responseErrorInterceptor
);

export default axiosInstance;
